import { URL_CONST } from 'constants/urls'
import React, { ReactChild } from 'react'
import { RouterLinkStyled, ExternalLinkStyled } from './styles'

export interface TextButtonProps {
  external?: boolean
  url?: string
  target?: '_blank' | '_self'
  children?: ReactChild
  disabled?: boolean
  onClick?: React.MouseEventHandler<HTMLAnchorElement>
}

export const TextButton = ({
  external,
  url,
  target = '_blank',
  children,
  disabled = false,
  onClick
}: TextButtonProps) => {
  if (external) {
    return (
      <ExternalLinkStyled
        data-testid="external_button"
        onClick={onClick}
        target={target}
        {...(url && { href: url })}
        disabled={disabled}
      >
        {children}
      </ExternalLinkStyled>
    )
  }

  return (
    <RouterLinkStyled
      onClick={onClick}
      to={url || URL_CONST.ROOT}
      disabled={disabled}
      data-testid="internal_button"
    >
      {children}
    </RouterLinkStyled>
  )
}
